import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loading from 'components/Loading/index';
import api from 'api';
import { __ } from 'locale';
import { setLectureTaskData, setLectureTaskCompleteSaved } from 'actions/index';

const itemClass = 'flex items-center bg-[#efefef] px-[1em] py-[0.5em] mb-[0.5em]';
const itemH2Class = 'text-[1em] font-bold m-0';
const itemPClass = 'text-[0.9em] text-[#444] mt-[0.5em] mb-0';
const itemPInfoClass = 'text-[0.85em] text-[#444] mt-[0.5em] mb-0';
const itemAsideClass = 'ml-auto text-[0.85em]';
const btnBase = 'inline-block py-[0.5em] px-[0.65em] text-white no-underline rounded ml-[4px] cursor-pointer';
const btnGreen = `${btnBase} bg-[#26AA52] hover:bg-[#2bbf5c]`;
const btnGray = `${btnBase} bg-[#999]`;
const btnRed = `${btnBase} bg-[#f34]`;

function DialogLoadLectureTask({ onLoaded }) {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [renameTaskId, setRenameTaskId] = useState(0);
    const [renameText, setRenameText] = useState('');
    const [deleteTaskId, setDeleteTaskId] = useState(0);
    const [taskComment, setTaskComment] = useState(null);

    const loadTasks = () => {
        api('lecturetask/list/' + data.appModeData.lectureId).then(result => {
            setTasks(result.data.tasks);
            setLoading(false);
        });
    };

    useEffect(() => { loadTasks(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const openTask = (id) => {
        api('lecturetask/load/' + id, { post: true, data: { lectureId: data.appModeData.lectureId } }).then(res => {
            const found = tasks.find(t => t.id === id);
            if (found) {
                const ltData = { ...data.lectureTaskData, lastLoadedTitle: found.title };
                dispatch(setLectureTaskData(ltData));
                if (res.data.task_meta.is_complete === 1) {
                    dispatch(setLectureTaskCompleteSaved(true));
                }
            }
            onLoaded(res.data.task_meta.is_complete === 1);
        });
    };

    const cancelTargetTask = () => {
        setRenameTaskId(0);
        setRenameText('');
        setDeleteTaskId(0);
    };

    const doRenameTask = () => {
        api('lecturetask/rename', { post: true, data: { id: renameTaskId, text: renameText } }).then(() => {
            loadTasks();
            cancelTargetTask();
        });
    };

    const doDeleteTask = () => {
        api('lecturetask/delete', { post: true, data: { id: deleteTaskId } }).then(() => {
            loadTasks();
            cancelTargetTask();
        });
    };

    const saveTaskComment = () => {
        api('lecturetask/update-comment', { post: true, data: { id: taskComment.id, text: taskComment.comment } }).then(() => {
            loadTasks();
            setTaskComment(null);
        });
    };

    if (loading) return <Loading />;

    if (taskComment) {
        return (
            <div className="flex flex-col p-[1em]">
                <h2 className="text-[1.4em] flex items-center">
                    <a className="text-[1em] border border-[#aaa] text-[#888] rounded-full flex w-[1.25em] h-[1.25em] items-center justify-center mr-[0.5rem] cursor-pointer hover:bg-[#aaa] hover:text-white" onClick={() => setTaskComment(null)}><i className="fa fa-angle-left"></i></a>
                    Poznámka
                </h2>
                <p>{__('K uloženému úkolu')} „{taskComment.title}"</p>
                <textarea className="block w-full h-[15em]" onChange={e => setTaskComment({ ...taskComment, comment: e.target.value })} value={taskComment.comment}></textarea>
                <button className="self-start whitespace-nowrap font-bold text-[0.9em] bg-[#26AA52] cursor-pointer text-white py-[0.5rem] px-[0.75rem] no-underline rounded text-center mt-[1em] border-0 hover:bg-[#2bbf5c]" type="button" onClick={saveTaskComment}>{__('Uložit poznámku')}</button>
            </div>
        );
    }

    const taskList = tasks.map(task => {
        const comment = task.comment !== '' ? <p className={itemPClass}>Poznámka: {task.comment}</p> : null;

        if (task.id === renameTaskId) {
            return (
                <div className={itemClass} key={task.id}>
                    <article className="flex-1">
                        <p className={itemPClass}>
                            <input type="text" style={{fontWeight:'bold',width:'100%',padding:'4px 5px'}} onChange={e => setRenameText(e.target.value)} value={renameText} />
                        </p>
                        <p className={itemPInfoClass}>{task.course_title} / {task.lecture_title}</p>
                        {comment}
                    </article>
                    <aside className={itemAsideClass}>
                        <a className={btnGreen} onClick={doRenameTask}>{__('Uložit')}</a>
                        <a className={btnGray} onClick={cancelTargetTask}>{__('Zpět')}</a>
                    </aside>
                </div>
            );
        }

        if (task.id === deleteTaskId) {
            return (
                <div className={itemClass} key={task.id}>
                    <article className="flex-1">
                        <h2 className={itemH2Class} style={{color:'#f00'}}>{task.title}</h2>
                        <p className={itemPInfoClass}>{task.course_title} / {task.lecture_title}</p>
                        {comment}
                    </article>
                    <aside className={itemAsideClass}>
                        <a className={btnRed} onClick={doDeleteTask}>Potvrdit smazání</a>
                        <a className={btnGray} onClick={cancelTargetTask}>Zpět</a>
                    </aside>
                </div>
            );
        }

        return (
            <div className={itemClass} key={task.id}>
                <article className="flex-1">
                    <h2 className={itemH2Class}>{task.title}</h2>
                    <p className={itemPInfoClass}>{task.course_title} / {task.lecture_title}</p>
                    {comment}
                </article>
                <aside className={itemAsideClass}>
                    <a className={btnGreen} onClick={() => openTask(task.id)}>{__('Načíst')}</a>
                    <a className={btnGray} onClick={() => setTaskComment(task)}>{__('Poznámka')}</a>
                    <a className={btnGray} onClick={e => { e.preventDefault(); if (e.target !== e.currentTarget) return; setRenameTaskId(task.id); setRenameText(task.title); }}>{__('Přejmenovat')}</a>
                    <a className={btnRed} onClick={e => { e.preventDefault(); if (e.target !== e.currentTarget) return; setDeleteTaskId(task.id); }}>{__('Smazat')}</a>
                </aside>
            </div>
        );
    });

    return <>{taskList}</>;
}

export default DialogLoadLectureTask;
